import React from "react";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";

/**
 * PageLoader — clean, minimal, professional
 *
 * Props:
 *   title  {string}            — Caption below the spinner.  Default: "Loading..."
 *   minH   {string}            — Tailwind min-height class.  Default: "min-h-[60vh]"
 *   icon   {React.ElementType} — Heroicon component.         Default: ShieldCheckIcon
 */
const PageLoader = ({
  title = "Loading...",
  minH = "min-h-[60vh]",
  icon: Icon = ShieldCheckIcon,
}) => (
  <div className={`flex items-center justify-center w-full ${minH}`}>
    <div className="flex flex-col items-center gap-5">

      {/* Icon + spinner ring */}
      <div className="relative w-14 h-14 flex items-center justify-center">
        {/* Track ring */}
        <svg className="absolute inset-0 w-14 h-14" viewBox="0 0 56 56" fill="none">
          <circle cx="28" cy="28" r="24" stroke="#E2E8F0" strokeWidth="3" />
        </svg>
        {/* Spinning arc */}
        <svg
          className="absolute inset-0 w-14 h-14 animate-spin"
          style={{ animationDuration: "0.9s" }}
          viewBox="0 0 56 56"
          fill="none"
        >
          <circle
            cx="28" cy="28" r="24"
            style={{ stroke: "var(--app-primary-color, #26256b)" }}
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="38 113"
            strokeDashoffset="0"
          />
        </svg>
        {/* Icon */}
        <Icon className="w-5 h-5 relative z-10" style={{ color: "var(--app-primary-color, #26256b)" }} />
      </div>

      {/* Text */}
      <div className="text-center space-y-1">
        <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{title}</p>
        <div className="flex items-center justify-center gap-1">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="inline-block w-1 h-1 rounded-full bg-primary-500"
              style={{
                backgroundColor: "var(--app-primary-color, #26256b)",
                animation: `pageloader-dot 1.2s ease-in-out ${i * 0.2}s infinite`,
              }}
            />
          ))}
        </div>
      </div>

    </div>

    <style>{`
      @keyframes pageloader-dot {
        0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
        40%            { opacity: 1;   transform: scale(1.2); }
      }
    `}</style>
  </div>
);

export default PageLoader;
